import React from "react";
import Sidebar from "../sidebar";
import AdminContent from "../admin-content";
import { useLocation } from "react-router";

const Dashboard = () => {
  const location = useLocation();

  return (
    <div className="flex justify-between h-screen bg-gray-100">
      {/* Sidebar */}
      <Sidebar />

      {/* Main Content */}
      <div className="flex-1 lg:flex-[0.85] p-6 overflow-y-auto ">
        <AdminContent activeTab={location.pathname} />
      </div>
    </div>
  );
};

export default Dashboard;
